"use client";

/**
 * NewForm DS hover icon — an arrow dropping into a tray, for "download".
 * On hover the arrow dips toward the tray and returns; the tray holds still,
 * so the motion reads as the file going somewhere rather than the whole
 * glyph twitching.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function DownloadIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="a-drop">
        <path d="M12 3.6v9.8" />
        <path d="m7.9 9.5 4.1 4.1 4.1-4.1" />
      </g>
      <path d="M4.4 16.4v2.4a1.6 1.6 0 0 0 1.6 1.6h12a1.6 1.6 0 0 0 1.6-1.6v-2.4" />
    </HoverIconSvg>
  );
}
